import React, { useState } from 'react'
import Info from './info'
import EyeOpenIcon from '../assets/svg/eye.svg'
import EyeClosedIcon from '../assets/svg/view-off.svg'

const PasswordInput = ({
  name,
  placeholder,
  label,
  value,
  inputRef,
  infos,
  onChange,
  onKeyDown,
  readOnly,
  error,
  errorMessage,
  className,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <div className='relative w-full'>
      {label && (
        <label
          className={`text-[12px] leading-[17px] font-normal text-color-gray`}
        >
          {label}
        </label>
      )}
      <div
        className={`flex items-center justify-between w-full border !border-gray bg-white rounded-md !h-[40px] px-2
         ${error ? '!bg-[#FBEDEA] !border-error focus:!border-error' : ''}
      `}
      >
        <input
          type={showPassword ? 'text' : 'password'}
          name={name}
          placeholder={placeholder}
          value={value}
          className={`w-[95%] !h-[40px] border-y border-y-gray text-color-black text-[12px] outline-none `}
          ref={inputRef}
          onChange={onChange}
          onKeyDown={onKeyDown}
          readOnly={readOnly ? true : false}
          {...rest}
        />
        <button
          type='button'
          onClick={() => setShowPassword(!showPassword)}
          className='text-gray-600 hover:text-black'
        >
          {showPassword ? (
            <img src={EyeClosedIcon} alt='Hide password' />
          ) : (
            <img src={EyeOpenIcon} alt='Show password' />
          )}
        </button>
      </div>

      {error && (
        <span className='text-error text-[12px] italic'>* {errorMessage}</span>
      )}
      {infos && <Info infos={infos} />}
    </div>
  )
}

export default PasswordInput
